module.exports = __webpack_public_path__ + "528822f9ffa1d133ce1c696264fab53a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/calibre/calibre.eot
// module id = 708
// module chunks = 0